
import Vue from 'vue';
import { TransformedCmAccordion } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    standalone: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object as () => TransformedCmAccordion['data'],
      required: true,
    },
  },
  data() {
    return {
      headlineObject: {
        text: this.data.headline,
        fontStyle: this.data.headlineSize === 'default' ? 'h2' : 'h3',
      },
    };
  },
});
